<template>
  <div class="ww">
    <div
      class="dlbt"
      style="background-color:white;border-radius:8px;padding: 15px 15px; "
    >
      <div
        v-for="(item, index) in [
          '求购类别',
          categorys_name != '不限' ? '公司行业' : '',
          '省份',
          citys.length != 0 ? '城市' : '',
          regions.length != 0 ? '区县' : '',
        ]"
        :key="index"
      >
        <div
          class="dytop dbt"
          style="margin:  10px 0; line-height:25px; font-size:14px;"
          v-if="item != ''"
        >
          <!-- 第一列 -->
          <div class="dx" style="min-width:100px;">{{ item }}：</div>
          <!-- 第二列 -->
          <div class="ds" style="width:100%;">
            <!-- 求购类别 -->
            <div
              v-if="item == '求购类别'"
              class="ds"
              :style="{ width: '100%' }"
            >
              <div
                :class="
                  categorys_name == item.category_name
                    ? 'btn btn-checked'
                    : 'btn'
                "
                v-for="item in categorys"
                :key="item.category_name"
                @click="onCheck(item, index)"
              >
                {{ item.category_name }}
              </div>
            </div>
            <!-- 公司行业 -->
            <div
              v-if="item == '公司行业'"
              class="dwp"
              :style="expand_0 ? '' : 'height:25px;overflow:hidden'"
            >
              <div
                :class="
                  industrys_name == item.category_name
                    ? 'btn btn-checked'
                    : 'btn'
                "
                v-for="item in industrys"
                :key="item.category_name"
                @click="onCheck(item, index)"
              >
                {{ item.category_name }}
              </div>
            </div>
            <!-- 省份 -->
            <div
              class="dwp"
              v-if="item == '省份'"
              :style="expand_1 ? '' : 'height:25px;overflow:hidden'"
            >
              <div
                :class="provinces_name == item.name ? 'btn btn-checked' : 'btn'"
                v-for="item in provinces"
                :key="item.id"
                @click="onCheck(item, index)"
              >
                {{ item.name }}
              </div>
            </div>
            <!-- 城市 -->
            <div
              class="dwp"
              v-if="item == '城市'"
              :style="expand_2 ? '' : 'height:25px;overflow:hidden'"
            >
              <div
                :class="citys_name == item.name ? 'btn btn-checked' : 'btn'"
                v-for="item in citys"
                :key="item.id"
                @click="onCheck(item, index)"
              >
                {{ item.name == "所有" ? "不限" : item.name }}
              </div>
            </div>
            <!-- 区县 -->
            <div
              class="dwp"
              v-if="item == '区县'"
              :style="expand_3 ? '' : 'height:25px;overflow:hidden'"
            >
              <div
                :class="regions_name == item.name ? 'btn btn-checked' : 'btn'"
                v-for="item in regions"
                :key="item.id"
                @click="onCheck(item, index)"
              >
                {{ item.name == "所有" ? "不限" : item.name }}
              </div>
            </div>
          </div>
          <!-- 第三列 -->
          <div style="user-select: none;">
            <div
              v-if="item == '公司行业'"
              @click="expand_0 = !expand_0"
              style="min-width:50px; color:#0085d0;cursor: pointer; "
            >
              {{ expand_0 ? "收起" : "展开" }}
            </div>
            <div
              v-if="item == '省份'"
              @click="expand_1 = !expand_1"
              style="min-width:50px; color:#0085d0;cursor: pointer; "
            >
              {{ expand_1 ? "收起" : "展开" }}
            </div>
            <div
              v-if="item == '城市'"
              @click="expand_2 = !expand_2"
              style="min-width:50px; color:#0085d0;cursor: pointer; "
            >
              {{ expand_2 ? "收起" : "展开" }}
            </div>
            <div
              v-if="item == '区县'"
              @click="expand_3 = !expand_3"
              style="min-width:50px; color:#0085d0;cursor: pointer; "
            >
              {{ expand_3 ? "收起" : "展开" }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 条件区域
import * as Api from "../api";
export default {
  name: "ConditionalArea",
  data() {
    return {
      expand_0: false,
      expand_1: false,
      expand_2: false,
      expand_3: false,
      categorys_name: "不限",
      categorys: [
        {
          category_id: "",
          category_name: "不限",
        },
      ],
      industrys_name: "不限",
      industrys: [
        {
          category_id: "5",
          category_name: "不限",
        },
      ],
      provinces_name: "不限",
      provinces: [
        {
          id: "",
          name: "不限",
          parent_id: "1",
        },
      ],
      citys_name: "所有",
      citys: [], // 城市
      regions_name: "所有",
      regions: [], // 区域
    };
  },
  methods: {
    async onCheck(e, index) {
      switch (index) {
        case 0:
          this.categorys_name = e.category_name;
          this.industrys_name = "不限";
          this.industrys = [
            this.industrys[0],
            ...(await Api.makeover_api_common({ parent_id: e.category_id }))
              .list,
          ];
          break;
        case 1:
          this.industrys_name = e.category_name;
          break;
        case 2: // 省
          this.provinces_name = e.name;
          this.citys_name = "所有";
          this.regions_name = "所有";
          if (this.provinces_name == "不限") {
            console.log("fasfsdfsadfasdf");
            this.citys = [];
            this.regions = [];
          } else {
            this.citys = [...(await Api.get_province(e.id))];
          }
          break;
        case 3: // 市
          console.log(e);
          this.citys_name = e.name;
          this.regions_name = "所有";
          if (this.citys_name == "所有") {
            this.regions = [];
          } else {
            this.regions = [...(await Api.get_province(e.id))];
          }
          break;
        case 4: // 区
          this.regions_name = e.name;
          break;
      }
      this.$emit("conditions", {
        category_id: (() => {
          return this.industrys_name == "不限"
            ? this.categorys.reduce((id, item) => {
                if (item.category_name == this.categorys_name) {
                  id = item.category_id;
                }
                return id;
              }, "")
            : this.industrys.reduce((id, item) => {
                if (item.category_name == this.industrys_name) {
                  id = item.category_id;
                }
                return id;
              }, "");
        })(), // 类别
        province_id: (() => {
          return this.provinces.reduce((id, item) => {
            if (item.name == this.provinces_name) {
              id = item.id;
            }
            return id;
          }, "");
        })(), // 省份
        city_id: (() => {
          return this.citys.reduce((id, item) => {
            if (item.name == this.citys_name) {
              id = item.id;
            }
            return id;
          }, "");
        })(), // 城市
        region_id: (() => {
          return this.regions.reduce((id, item) => {
            if (item.name == this.regions_name) {
              id = item.id;
            }
            return id;
          }, "");
        })(), // 区域
        page: "1",
        page_size: "20",
      });
    },
  },
  async created() {
    this.categorys = [
      this.categorys[0],
      ...(await Api.makeover_api_common({ parent_id: "0" })).list
    ]
    this.industrys = [
      this.industrys[0],
      ...(await Api.makeover_api_common({ parent_id: "1" })).list,
    ];
    this.provinces = [...this.provinces, ...(await Api.get_province("1"))];
  },
};
</script>
<style scoped>
.btn {
  /* background-color: red; */
  white-space: nowrap;
  margin: 0px 5px 10px 5px;
  padding: 0 10px;
  border-radius: 100px;
  /* color:white; */
}
.btn-checked {
  background-color: red;
  white-space: nowrap;
  margin: 0px 5px 10px 5px;
  padding: 0 10px;
  border-radius: 100px;
  color: white;
}
</style>
